// Q under jakt: medan Q lyssnar eller pratar pausas jaktens transkription (annars hamnar frågan och svaret i
// jaktloggen, och mikrofonen delas), och medan Q lyssnar är LiveKit-mikrofonen av så att jaktlaget inte hör
// frågan. Mötet fortsätter. Allt återställs `resumeMs` efter att Q tystnat (en ny mening avbryter återställningen).
// QPanel anropar med listening: true redan innan Q börjar lyssna och väntar på det returnerade löftet: släpper
// jakten mikrofonen just då får iOS `releaseMs` på sig innan Q:s egen ljudmotor startar (QB1, annars hörde Q
// ingenting eftersom WebKit fortfarande höll mikrofonen).

export interface HuntAudio {
  /** Körs transkriptionen nu? */
  transcribing(): boolean;
  stopTranscription(): void;
  startTranscription(): void;
  /** Är LiveKit-mikrofonen på (jägarens val)? */
  micOn(): boolean;
  setMic(on: boolean): void;
  /** Pågår jakten fortfarande när det är dags att återställa? */
  huntActive(): boolean;
}

export function createQHuntPause(audio: HuntAudio, resumeMs = 700, releaseMs = 300) {
  let paused: { transcribe: boolean; mic: boolean } | null = null;
  let timer: ReturnType<typeof setTimeout> | null = null;

  return (s: { listening: boolean; speaking: boolean }): Promise<void> => {
    if (s.listening || s.speaking) {
      if (timer) { clearTimeout(timer); timer = null; }
      let released = false;
      if (!paused) {
        paused = { transcribe: audio.transcribing(), mic: false };
        if (paused.transcribe) { audio.stopTranscription(); released = true; }
      }
      if (s.listening && !paused.mic && audio.micOn()) {
        paused.mic = true;
        audio.setMic(false);
        released = true;
      }
      return released && s.listening ? new Promise(r => setTimeout(r, releaseMs)) : Promise.resolve();
    }
    if (!paused || timer) return Promise.resolve();
    timer = setTimeout(() => {
      timer = null;
      const p = paused;
      paused = null;
      if (!p || !audio.huntActive()) return;
      if (p.mic && audio.micOn()) audio.setMic(true);
      if (p.transcribe) audio.startTranscription();
    }, resumeMs);
    return Promise.resolve();
  };
}
